import { render, staticRenderFns } from "./pop-swiper.vue?vue&type=template&id=a19a49d8&scoped=true"
import script from "./pop-swiper.vue?vue&type=script&lang=js"
export * from "./pop-swiper.vue?vue&type=script&lang=js"
import style0 from "./pop-swiper.vue?vue&type=style&index=0&id=a19a49d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19a49d8",
  null
  
)

export default component.exports